import { Container } from "@chakra-ui/react";

export default function MainContent({ large, children, ...rest }) {
  const size = large ? "1588px" : "container.xl";
  return (
    <Container maxW={size} position="relative" px={0} pb="32px" {...rest}>
      {children}
    </Container>
  );
}
